import { GenericManageAdminPage } from '~/components/GenericManageAdminPage/GenericManageAdminPage';
import { useCreateDistrictAdminMutation, useRemoveDistrictAdminMutation } from '../mutations';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useDistrictAdminListQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { can } = useAuthentication();

  const removeMutation = useRemoveDistrictAdminMutation();
  const createMutation = useCreateDistrictAdminMutation();
  const query = useDistrictAdminListQuery(id);

  return (
    <GenericManageAdminPage
      showCreate={can('create-district-admin', id)}
      showRemove={can('delete-district-admin', id)}
      title="Distriktsadministratörer"
      removeMutation={removeMutation}
      createMutation={createMutation}
      entityId={id}
      query={query}
    />
  );
}
